<script>
	export let videos = []
</script>

<div class="show-vids">
	{#each videos as vid}
		<div>
			<iframe
				src="https://youtube.com/embed/{vid}"
				frameborder="0"
				title="video" />
		</div>
	{/each}
</div>
